import { Injectable } from '@angular/core'
import { SharedModule } from '@tv3/shared/shared.module'
import { AirbnbUpdateBookingPrefDialogComponent } from './airbnb-update-booking-pref-dialog.component'
import { ConnectionView } from '@tv3/store/connection/connection.view'
import { MatDialogConfig } from '@angular/material/dialog'
import { DialogService } from '@tokeet-frontend/tv3-platform'

@Injectable({
  providedIn: SharedModule,
})
export class AirbnbUpdateBookingPrefDialogService {
  constructor(private sidePanel: DialogService) {}

  open(connection: ConnectionView) {
    const defaultConfig: MatDialogConfig = {
      panelClass: ['drawer-full-80'],
      data: { connection },
    }

    return this.sidePanel.openDrawer(AirbnbUpdateBookingPrefDialogComponent, defaultConfig)
  }
}
